import Amplitude from 'amplitude';
import * as esFoodParser from './esFoodParser';
let _ = require('lodash');
const amplitude = new Amplitude(process.env.REACT_APP_AMPLITUDE_API_TOKEN);

// IMPORTANT: This should match the USER_PROPERTY in vivabot project. FUTURE: Put in shared lib.
export const USER_PROPERTY = {
  Stage: 'Stage',
  FoodReportPreference: 'FoodReportPreference',
  Status: 'Status',
  BodyStat_Weight: 'BodyStat_Weight',
  BodyStat_Waist: 'BodyStat_Waist',
  BodyStat_Neck: 'BodyStat_Neck',
  BodyStat_Bicep: 'BodyStat_Bicep', // <left, right>
  BodyStat_Hip: 'BodyStat_Hip',
  BodyStat_Thigh: 'BodyStat_Thigh', // <left, right>
  BodyStat_Calf: 'BodyStat_Calf' // <left, right>
};

// KEEP THIS IN SYNC WITH vivaapi
const OMIT_FROM_CORRECTIONS_ANALYTICS = ["Wfds7rzkUjO1wt5o6W8Hj46ZYyi1"];

export const FOOD_PREFERENCE = {
  Show: 'Show',
  Hide: 'Hide'
};

export function updateUserProperties(userId, properties) {
  var data = {
    user_id: userId,
    user_properties: properties
  };
  amplitude.identify(data)
}

export function logDataEntryError(errorName, userId, dataPersonId) {
  let data = {
    event_type: 'DataEntryError',
    user_id: userId,
    session_id: Date.now(),
    user_properties: {
      DataPersonId: dataPersonId
    },
    event_properties: {
      ErrorName: errorName
    }
  };

  amplitude.track(data).then(() => {
    //console.log(`logFoodEntryEvent done! userId=${userId}, event_propertes=${JSON.stringify(data.event_properties)}`)
  }).catch(function (error) {
    console.error(`logDataEntryError error: ${error} for user ${userId}`)
  });
}

export function logFoodEntryEvent(userId, sectionType, sourceName,
  mappedFoodObj, actualFoodName, actualBrandName, actualServingName, originalText, parsedFoodObj
) {
  let data = {
    event_type: 'FoodEntry',
    user_id: userId,
    session_id: Date.now(),
    event_properties: {
      Selection: 'Manual'
    }
  };

  if (sectionType) { // section type maps to a dropdown-selected item, so no section type means this is manual
    if (sectionType === esFoodParser.HIT_TYPE.UserHistory) {
      data.event_properties.Selection = 'User';
    } else if (sourceName) {
      if (sourceName === esFoodParser.SOURCE_NAME.FS_Food || sourceName === esFoodParser.SOURCE_NAME.FS_Recipe) {
        data.event_properties.Selection = 'External_FatSecret';
      } else {
        console.assert(false, `logFoodEntryEvent: error: unexpected sourceName ${sourceName}`);
      }
    } else {
      console.assert(false, `logFoodEntryEvent: error: unexpected sectionType ${sectionType} with no sourceName!`);
    }
  }

  if (!_.isEmpty(mappedFoodObj)) {
    data.event_properties.FoodNameMappedCorrectly = areSameCaseInsensitiveString(actualFoodName, mappedFoodObj.name);
    data.event_properties.BrandNameMappedCorrectly = areSameCaseInsensitiveString(actualBrandName, mappedFoodObj.brandName);

    let actualParsedServing = esFoodParser.parseServingDescription(actualServingName);
    let actualServingUnit = actualParsedServing.servingUnit;
    let mappedParsedServing = esFoodParser.parseServingDescription(mappedFoodObj.servingName ? mappedFoodObj.servingName : '');
    let mappedServingUnit = mappedParsedServing.servingUnit;
    data.event_properties.ServingNameMappedCorrectly = areSameCaseInsensitiveString(actualServingUnit, mappedServingUnit);
  }

  amplitude.track(data).then(() => {
    //console.log(`logFoodEntryEvent done! userId=${userId}, event_propertes=${JSON.stringify(data.event_properties)}`)
  }).catch(function (error) {
    console.error(`logFoodEntryEvent error: ${error} for user ${userId}`)
  });
}

function areSameCaseInsensitiveString(str1, str2) {
  if (!str1 && !str2) {
    return true;
  }

  if (str1 && !str2) {
    return false;
  }

  if (str2 && !str1) {
    return false;
  }

  if (str1.toLowerCase() === str2.toLowerCase()) {
    return true;
  }
  return false;
}

export function logFoodSubmitForm(userId, dataPersonId, timeElapsed, timeSpentByDEP, numLogs) {
  let data = {
    event_type: 'DataEntry_Food_SubmitForm',
    user_id: userId,
    session_id: Date.now(),
    user_properties: {
      DataPersonId: dataPersonId
    },
    event_properties: {
      'TimeElapsed': timeElapsed,
      'TimeSpentByAdmin': timeSpentByDEP,
      "NumLogs": numLogs,
      "TimeSpentPerTodo": numLogs >= 1 ? timeSpentByDEP / numLogs : 0
    }
  };

  amplitude.track(data).then(() => {
    console.log(`logFoodSubmitForm done! userId=${userId}, event_propertes=${JSON.stringify(data.event_properties)}`)
  }).catch(function (error) {
    console.error(`logDataEntryError error: ${error} for user ${userId}`)
  });
}

export function logDEPNeedsHelp(userId, dataPersonId, status, timeElapsed /* null if isResolved is false*/) {
  let data = {
    event_type: 'DataEntry_Food_NeedsHelp',
    user_id: userId,
    session_id: Date.now(),
    user_properties: {
      DataPersonId: dataPersonId
    },
    event_properties: {
      'Status': status,
      'TimeElapsed': timeElapsed
    }
  };

  amplitude.track(data).then(() => {
    console.log(`logDEPNeedsHelp done! userId=${userId}, event_propertes=${JSON.stringify(data.event_properties)}`)
  }).catch(function (error) {
    console.error(`logDEPNeedsHelp error: ${error} for user ${userId}`)
  });
}


export function logDEMergeConflict(userId, dataPersonId, decision) {
  let data = {
    event_type: 'DataEntry_Food_NeedsHelp',
    user_id: userId,
    session_id: Date.now(),
    user_properties: {
      DataPersonId: dataPersonId
    },
    event_properties: {
      'Decision': decision
    }
  };

  amplitude.track(data).then(() => {
    console.log(`logDEMergeConflict done! userId=${userId}, event_propertes=${JSON.stringify(data.event_properties)}`)
  }).catch(function (error) {
    console.error(`logDEMergeConflict error: ${error} for user ${userId}`)
  });
}

export function logDEPCorrection(userId, dataPersonId /* This is the id of the DEP that made mistake, not the one that's doing the correction */) {
  if (!OMIT_FROM_CORRECTIONS_ANALYTICS.includes(userId)) {
    let data = {
      event_type: 'DataEntry_Food_Correct',
      user_id: userId,
      session_id: Date.now(),
      user_properties: {
        DataPersonId: dataPersonId
      }
    };

    amplitude.track(data);
  }
}


// WEBPACK FOOTER //
// ./src/helpers/Analytics.js